import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"

dayjs.extend(customParseFormat)

// with the transition to just one and small date library in the ui
// we need to map luxon date formats from bff to dayjs formats in ui
// https://github.com/moment/luxon/blob/master/docs/parsing.md#table-of-tokens
// https://day.js.org/docs/en/display/format
export const parseIsoDate = (isoDate: string, outputFormat: string) => {
	const date = dayjs(isoDate)
	return date.isValid() ? date.format(outputFormat.toUpperCase()) : undefined
}

export const isValidDateValue = (value: string | undefined | null): boolean => dayjs(value).isValid()

export const toOnChangeValue = (
	value: string,
	dateFormat: string,
): {
	input: string
	isoDate: string | null
	isValid: boolean
} => {
	const date = dayjs(value, dateFormat.toUpperCase())
	const isValid = date.isValid()

	return {
		input: value,
		isoDate: isValid ? date.format("YYYY-MM-DD") : null,
		isValid,
	}
}
